import React from 'react';
import { object, number, arrayOf, bool, func, string } from 'prop-types';
import SearchListing from 'components/search-listing/SearchListing';

export default function TabItemsSection({
    tabContent, tabContentId, totalItems, showingItems, showMoreButtonType,
    showMoreItems, showMoreButtonLabel
}) {
    return (
        <div id={tabContentId} className="tab-content-wrapper">
            <div className="container">
                {tabContent.map(item => (
                    <SearchListing item={item} key={item.guid} />
                ))}

                {totalItems > showingItems ?
                    <div
                        className={`js-react-load-more-on-scroll btn-more ${showMoreButtonType ? 'btn-skin-1' : 'btn-text'}`}
                        onClick={showMoreItems}
                        onKeyPress={e => { if (e.key === 'Enter') { this.props.showMoreItems.call(this, null); } }}
                        role="button"
                        tabIndex="0"
                    >
                        {showMoreButtonLabel} &darr;
                    </div> : false
                }
            </div>
        </div>
    );
}

TabItemsSection.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    tabContent: arrayOf(object).isRequired,
    tabContentId: number.isRequired,
    showMoreItems: func.isRequired,
    showingItems: number.isRequired,
    totalItems: number.isRequired,
    showMoreButtonLabel: string.isRequired,
    showMoreButtonType: bool.isRequired
    /* eslint-enable react/no-typos */
};
